export const CHANGE_TYPES = {
  tiptapChange: 'tiptapChange',
  selectionChange: 'selectionChange',
};
